import { atom } from 'jotai';

/** Estimated absolute ground Z per loaded point-cloud layer. */
export const pointcloudGroundZAtom = atom<Map<string, number>>(new Map());

/** Write-only: set (or, with z = null, delete) one layer's estimate. */
export const setPointcloudGroundZAtom = atom(
  null,
  (get, set, { layerId, z }: { layerId: string; z: number | null }) => {
    // A non-finite estimate (empty or corrupt root node) is no estimate at all.
    if (z !== null && !Number.isFinite(z)) return;
    const prev = get(pointcloudGroundZAtom);
    if (z === null) {
      if (!prev.has(layerId)) return;
    } else if (prev.get(layerId) === z) return;
    const next = new Map(prev);
    if (z === null) next.delete(layerId);
    else next.set(layerId, z);
    set(pointcloudGroundZAtom, next);
  },
);

/** Project ground estimate: median of the per-cloud values, or null. */
export const projectGroundZAtom = atom<number | null>((get) => {
  const vals = [...get(pointcloudGroundZAtom).values()].filter(Number.isFinite).sort((a, b) => a - b);
  if (vals.length === 0) return null;
  const mid = vals.length >> 1;
  return vals.length % 2 ? vals[mid] : (vals[mid - 1] + vals[mid]) / 2;
});
